<template>
  <div class="container">
    <div class="baner">
      <div v-if="userInfo && userInfo.showHospitalName" class="title">
        {{ hospitalName }}
      </div>
      <div class="diagnosisCardBox" v-if="currentUser">
        <div v-if="currentUser.diagnosisCardNo">
          <div class="contactName">
            {{ currentUser.cardholderName
            }}<span class="changeBtn" @click="contactShow = true">切换</span>
          </div>
          <div class="diagnosisCardNo">
            就诊卡号：{{ currentUser.diagnosisCardNo }}
          </div>
          <div class="qrcode" @click="showCode(true)">
            <img src="/images/code.png" alt="" />
          </div>
        </div>
        <div v-else>
          <div class="contactName" style="color: rgb(25,137,250);">
            暂无电子健康卡
          </div>
          <div class="diagnosisCardNo" style="color: #999">
            请您完成电子健康卡绑定
          </div>
          <div class="toBind" @click="toBind">
            去绑定
          </div>
        </div>
      </div>
      <van-overlay
        :show="showCodeFlag"
        @click="showCode(false)"
        v-if="currentUser"
      >
        <div class="wrapper">
          <div class="qrcodeBox" @click.stop>
            <div class="topBox">出示二维码</div>
            <van-tabs v-model="tabActive" ref="tabs">
              <van-tab
                v-if="SettingList.displayCasehistoryNo"
                title="门诊号"
                style="paddingtop: 8px"
              >
                <qrcode
                  v-if="currentUser.caseHistoryNo"
                  :value="currentUser.caseHistoryNo"
                  :options="{ size: 150 }"
                ></qrcode>
                <p>{{ currentUser.caseHistoryNo }}</p>
              </van-tab>
              <van-tab
                v-if="currentUser.diagnosisCardNo"
                title="就诊卡"
                style="paddingtop: 8px"
              >
                <qrcode
                  v-if="currentUser.diagnosisCardNo"
                  :value="currentUser.diagnosisCardNo"
                  :options="{ size: 150 }"
                ></qrcode>
                <p>{{ currentUser.diagnosisCardNo }}</p>
              </van-tab>
              <van-tab
                title="电子健康码"
                style="paddingtop: 8px"
                v-if="currentUser.qrCodeText"
              >
                <div class="qrcode-wraper">
                  <qrcode
                    v-if="currentUser.qrCodeText"
                    :value="currentUser.qrCodeText"
                    :options="{ size: 150 }"
                  ></qrcode>
                  <img class="qrcode-image" src="/images/ybk-logo.png" />
                </div>
                <!-- <p>{{ currentUser.qrCodeText }}</p> -->
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </van-overlay>
      <!-- <action-sheet v-model="contactShow" close-on-click-action /> -->

      <action-sheet
        v-model="contactShow"
        close-on-click-action
        v-if="actionsList.length"
      >
        <ul>
          <li
            v-for="(item, index) in actionsList"
            :key="index"
            class="actions-list"
            @click="onChangeContact(item)"
          >
            <van-icon
              name="checked"
              v-if="item.isDefault"
              color="rgb(41,121,255)"
              size="20px"
              class="isSelect"
            />
            <div class="name">{{ item.name }}</div>
            <div class="diagnosisCardNo">{{ item.diagnosisCardNo }}</div>
          </li>
        </ul>
      </action-sheet>
      <!-- <button @click="onClick">点击</button> -->
      <van-swipe :autoplay="3000" indicator-color="white" v-if="banner.length">
        <van-swipe-item
          v-for="(item, index) in banner"
          :key="index"
          style="font-size: 0"
        >
          <img
            :src="$config.fileUrl + '/' + item.imgUrl"
            class="baner-img"
            alt=""
          />
        </van-swipe-item>
      </van-swipe>
      <div v-else style="margin-top: 10px;height: 70px;"></div>
    </div>

    <div class="actions">
      <van-tabs v-model="active">
        <van-tab title="门诊">
          <router-link
            v-if="SettingList.enabledMobileTodayRegistration"
            tag="div"
            class="action-button"
            :to="{ path: '/serve/pre-order', query: { type: 'today' } }"
          >
            <div class="action-icon" style="background: #ff976a">
              <i class="iconfont iconjinricaigou"></i>
            </div>
            <div class="action-text">当日挂号</div>
          </router-link>
          <router-link
            v-if="SettingList.enabledMobileBookingRegistration"
            tag="div"
            class="action-button"
            to="/serve/pre-order"
          >
            <div class="action-icon" style="background: #1989fa">
              <i class="iconfont iconyuyuexuanzhong"></i>
            </div>
            <div class="action-text">预约挂号</div>
          </router-link>
          <router-link
            v-if="
              SettingList.enabledMobileBookingRegistration ||
                SettingList.enabledMobileTodayRegistration
            "
            tag="div"
            class="action-button"
            to="/serve/lineup"
          >
            <div class="action-icon" style="background: #07c160">
              <i class="iconfont icondengdai"></i>
            </div>
            <div class="action-text">排队候诊</div>
          </router-link>
          <router-link
            tag="div"
            class="action-button"
            to="/user/contact/CreatCardMenu"
            v-if="SettingList.enabledMobileSelfCreateCard"
          >
            <div class="action-icon" style="background: #f44336">
              <i class="iconfont iconqiabao"></i>
            </div>
            <div class="action-text">办理健康卡</div>
          </router-link>
          <router-link tag="div" class="action-button" to="/user/order/list">
            <div class="action-icon" style="background: #ffc107">
              <i
                class="iconfont iconyonghuziliaogerenxinxigerenziliao-xianxing"
              />
            </div>
            <div class="action-text">我的挂号</div>
          </router-link>
          <router-link
            v-if="SettingList.enabledMobileMyBills"
            tag="div"
            class="action-button"
            to="/user/bill/list"
          >
            <div class="action-icon" style="background: #07c160">
              <i class="iconfont iconrizhi" />
            </div>
            <div class="action-text">我的账单</div>
          </router-link>

          <router-link
            tag="div"
            class="action-button"
            to="/hospital/priceQuery"
            v-if="SettingList.enabledGoodsPriceSelect"
          >
            <div class="action-icon" style="background: #ffc107">
              <i class="iconfont iconzonghejiachaxun" />
            </div>
            <div class="action-text">价格查询</div>
          </router-link>
          <router-link
            v-if="SettingList.enabledMobileNucleinCheck"
            tag="div"
            class="action-button"
            to="/nuclein/check"
          >
            <div class="action-icon" style="background: #ff8917">
              <i
                class="iconfont iconyonghuziliaogerenxinxigerenziliao-xianxing"
              />
            </div>
            <div class="action-text">核酸检测</div>
          </router-link>
          <router-link
            v-if="SettingList.enabledMobileFreeNucleinCheck"
            tag="div"
            class="action-button"
            to="/nuclein/check?isFree=1"
          >
            <div class="action-icon" style="background: #ff976a">
              <i
                class="iconfont iconyonghuziliaogerenxinxigerenziliao-xianxing"
              />
            </div>
            <div class="action-text">核酸落地检</div>
          </router-link>
          <router-link
            v-if="SettingList.enabledMobileSelfHelp"
            tag="div"
            class="action-button"
            to="/selfHelp"
          >
            <div class="action-icon" style="background: #07c160">
              <i
                class="iconfont iconyonghuziliaogerenxinxigerenziliao-xianxing"
              />
            </div>
            <div class="action-text">体检自助</div>
          </router-link>
          <router-link
            v-if="SettingList.enabledQuestionnaire"
            tag="div"
            class="action-button"
            to="/user/contact/screeningForm/form?epidemicType=2"
          >
            <div class="action-icon" style="background: #ff976a">
              <i class="iconfont icon-smile" />
            </div>
            <div class="action-text">满意度调查</div>
          </router-link>
          <router-link
            v-if="SettingList.enabledMobileSelfItemNewOutPatient"
            tag="div"
            class="action-button"
            to="/selfBuy/check"
          >
            <div class="action-icon" style="background: #ff5c7d">
              <i class="iconfont icon-service" />
            </div>
            <div class="action-text">中医药验方特色产品</div>
          </router-link>
          <router-link
            v-if="SettingList.signInMode"
            tag="div"
            class="action-button"
            to="/user/contact/SignIn"
          >
            <div class="action-icon" style="background: #07c160">
              <i class="iconfont iconyuyue" />
            </div>
            <div class="action-text">签到</div>
          </router-link>
          <a
            v-if="SettingList.enabledViewPacsReport"
            class="action-button"
            :href="SettingList.viewPacsReportUrl"
          >
            <div class="action-icon" style="background: #07c160">
              <i class="iconfont iconyuyue" />
            </div>
            <div class="action-text">飞图影像</div>
          </a>
        </van-tab>
        <van-tab title="住院">
          <router-link
            v-if="SettingList.enabledMobileMyInHospital"
            tag="div"
            class="action-button"
            to="/user/inHospital/Index"
          >
            <div class="action-icon" style="background: #ff976a">
              <i class="iconfont icon-zhuyuan" />
            </div>
            <div class="action-text">我的住院</div>
          </router-link>
        </van-tab>
      </van-tabs>
    </div>
    <div class="flexBox">
      <div
        class="hospitalIntroduction"
        @click="$router.push('/hospital/basic')"
      >
        <van-icon
          name="column"
          color="#1989fa"
          size="28px"
          class="icon"
        />医院介绍
      </div>
      <div
        class="departmentIntroduction"
        @click="$router.push('/hospital/department')"
      >
        <van-icon
          name="records"
          color="#1989fa"
          size="24px"
          class="icon"
        />科室介绍
      </div>
    </div>
    <!-- <van-cell
      title="医院资讯"
      title-class="text-less"
      value-class="main-color"
      is-link
      :border="false"
      value="更多"
      style="margin-top: 0.5rem"
      to="/hospital/news"
    />
    <div class="box article-list">
      <DataList api="News_List" :params="MenuName">
        <template v-slot:item="item">
          <news-card :data="item.obj" @click="toNewsInfo(item.obj)" />
        </template>
      </DataList>
    </div>-->
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Icon,
  Cell,
  CellGroup,
  List,
  Card,
  Toast,
  Dialog,
  Overlay,
  Tab,
  Tabs,
  ActionSheet,
} from "vant";
import VueQrcode from "@xkeshi/vue-qrcode";
// import DataList from "@/components/DataList";
// import NewsCard from "@/components/NewsCard";
import { cache } from "@/utils/common";
import weChatPayBeforeMixin from "@/mixins/weChatPayBeforeMixin";
export default {
  name: "serveIndex",
  mixins: [weChatPayBeforeMixin],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [List.name]: List,
    [Card.name]: Card,
    [Overlay.name]: Overlay,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [VueQrcode.name]: VueQrcode,
    ActionSheet,
  },
  data() {
    return {
      abc: "1234",
      active: 0,
      actionsList: [],
      tabActive: 0,
      MenuName: { MenuName: "医院新闻" },
      banner: [],
      departmentList: [],
      list: {
        data: [],
        loading: false,
        finished: false,
      },
      SettingList: {},
      hospitalName: "",
      currentUser: {},
      showCodeFlag: false,
      contactShow: false,
      a: "123456",
      userInfo: {},
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.fullPath == "/") {
        vm.$post("Hospital_Info", {}).then((res) => {
          vm.hospitalName = res.data.name;
          if (res.data.bookingInformedRemark) {
            Dialog.alert({
              title: "挂号须知",
              message: res.data.bookingInformedRemark,
              messageAlign: "left",
            }).then(() => {});
          }
        });
      }
    });
  },
  // watch: {
  //   $route: {
  //     handler(data) {
  //       console.log(data);
  //     },
  //     immediate: true
  //   }
  // },
  updated() {},
  mounted() {},
  created() {
    this.$post("GetWxSystemParameterInfo", {}).then((res) => {
      const userInfo = cache.get("user");
      cache.set("user", { ...userInfo, ...res.data });
      this.SettingList = cache.get("user");
      console.log(this.SettingList);
      this.userInfo = userInfo;
    });
    this.getBanner();
    this.getDepartment();
    this.getContactList();
  },
  methods: {
    getContactList() {
      this.$post("Contact_List", {}).then((res) => {
        const data = res.data.datas;
        if (data.length) {
          data.map((p) => {
            p.name =
              p.cardholderName + " " + p.cardholderSexName + " " + p.age + "岁";
            p.subname = p.diagnosisCardNo;
            if (p.isDefault) {
              this.currentUser = p;
            }
          });
          this.actionsList = data;
        }
      });
    },
    getBanner() {
      this.$post("Banner", {
        PageIndex: 0,
        PageSize: 10,
      }).then((res) => {
        this.banner = res.data.datas;
      });
    },
    getDepartment() {
      this.$post("Department_List", {
        PageIndex: 0,
        PageSize: 10,
      }).then((res) => {
        this.departmentList = res.data.datas;
      });
    },
    toNewsInfo(item) {
      this.$router.push({
        name: "hospitalNewsInfo",
        query: {
          Id: item.id,
        },
      });
    },
    onLoadList() {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.data.push({
            title: "医院资讯" + i,
            intro:
              "这里是资讯的简介说明，如果很长很长很长很长很长很长很长很长的话",
            titlepic: "/pic.jpg",
            createTime: "2019-08-08",
          });
        }
        // 加载状态结束
        this.list.loading = false;

        // 数据全部加载完成
        if (this.list.data.length >= 20) {
          this.list.finished = true;
        }
      }, 500);
    },
    login() {
      const code = this.$route.query.code;
      console.log(code);
      const url = window.location.href;
      if (!code) {
        this.$post("login_GetUrl", {
          ReturnUrl: url,
        }).then((res) => {
          console.log(res);
          window.location.href = res.data;
        });
      } else {
        this.$post("login_GetInfo", {
          Code: code,
          ReturnUrl: "http://119.23.75.95:10429/serve/index",
        }).then(() => {});
      }
    },
    toDepartmentInfo(item) {
      this.$router.push({
        name: "hospitalDepartmentInfo",
        query: {
          Id: item.id,
        },
      });
    },
    showAlert() {
      Toast.fail("功能暂未开放");
    },
    // 展示二维码
    showCode(e) {
      this.showCodeFlag = e;
      this.$refs.tabs.resize();
    },
    // onClick() {
    //   // this.showCodeFlag = e;
    //   // this.$refs.tabs.resize();
    //   debugger;
    //   this.onWeChatPayBefore({
    //     a: 1,
    //     b: [1, 2, 3],
    //     c: {
    //       a: 1,
    //       b: [1, 2, 3],
    //       c: { a: 1 }
    //     }
    //   });
    // },
    onChangeContact(item) {
      this.currentUser = item;
      this.$post("SetIsDefaultCard", { id: item.id }).then();
      cache.set("currentContact", item, 24 * 60 * 60 * 1000);
      this.contactShow = false;
    },
    toBind() {
      this.$router.push({
        name: "userContactCreatCardMenu",
        query: {
          from: "index",
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.baner {
  position: relative;
  min-height: 100px;
  &-img {
    width: 100%;
    max-height: 260px;
  }
  .title {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 15px;
    z-index: 1;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 3px;
  }
  .diagnosisCardBox {
    position: absolute;
    bottom: -15px;
    height: 50px;
    width: 85%;
    left: 50%;
    z-index: 1;
    transform: translateX(-50%);
    background-color: #fff;
    box-shadow: 0px 5px 5px #f1f1f1;
    border-radius: 10px;
    padding: 10px;
    .contactName {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 5px;
    }
    .changeBtn {
      font-size: 12px;
      font-weight: normal;
      border: 1px solid rgb(76, 154, 239);
      color: rgb(76, 154, 239);
      border-radius: 20px;
      padding: 4px 15px;
      margin-left: 5px;
    }
    .diagnosisCardNo {
      font-weight: bold;
      font-size: 14px;
    }
    .qrcode {
      border: 1px solid #99999973;
      height: 50px;
      width: 50px;
      position: absolute;
      right: 10px;
      top: 9px;
      border-radius: 5px;
      img {
        height: 90%;
        width: 90%;
        margin: 5% 0 0 5%;
      }
    }
    .toBind {
      position: absolute;
      right: 10px;
      bottom: 17px;
      border: 1px solid rgb(25, 137, 250);
      border-radius: 8px;
      font-size: 18px;
      color: rgb(25, 137, 250);
      padding: 5px 10px;
    }
  }
}
.actions {
  overflow: hidden;
  margin: 0.5rem 0;
  .action-button {
    width: 23%;
    float: left;
    margin: 0 1%;
    // background: #dff4f4;
    text-align: center;
    font-size: 0.4rem;
    padding: 0.3rem 0;
    color: #333;
    // border-radius: 0.15rem;
    .action-icon {
      width: 40px;
      height: 40px;
      border-radius: 30px;
      text-align: center;
      display: inline-block;
      background: #ddd;
      line-height: 42px;
    }
    .action-text {
      font-size: 12px;
      margin-top: 5px;
      height: 30px;
      overflow: hidden;
    }
    .iconfont,
    .icon {
      font-size: 0.45rem;
      color: #fff;
    }
  }
}
.card-list {
  overflow: hidden;
  overflow-x: auto;
  margin: 0 0.3rem;
  ul {
    white-space: nowrap;
    li {
      width: 3rem;
      display: inline-block;
      font-size: 0.35rem;
      text-align: center;
      color: #555;
      & + li {
        margin-left: 0.3rem;
      }
      img {
        width: 100%;
      }
    }
  }
}
.article-list {
  .article-item {
    .title {
      font-weight: bold;
      font-size: 0.4rem;
    }
    .van-card__thumb {
      width: 1.7rem;
      height: 1.7rem;
    }
    .van-card__content {
      min-height: 1.7rem;
    }
    .thumb {
      img {
        width: 100%;
      }
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .qrcodeBox {
    height: 295px;
    width: 300px;
    // padding: 20px;
    background-color: #fff;
    text-align: center;
    border-radius: 0.2rem;
    overflow: hidden;
    .topBox {
      margin-bottom: 0.2rem;
      font-size: 0.4rem;
      line-height: 30px;
      width: 100%;
      height: 30px;
      color: #fff;
      background-image: linear-gradient(-45deg, #63b6f8, #0f78f3);
    }
    p {
      font-size: 0.4rem;
    }
  }
}

/deep/.van-tabs__line {
  background-image: linear-gradient(-45deg, #63b6f8, #0f78f3) !important;
}
/deep/.van-tabs__content {
  padding-top: 10px;
}
/deep/.van-overlay {
  z-index: 2;
}
/deep/.van-action-sheet__item {
  text-align: left;
  padding-left: 50px;
  border-bottom: 1px solid rgba(192, 192, 192, 0.41);
}
.actions-list {
  font-size: 16px;
  padding: 10px 20px 10px 40px;
  position: relative;
  border-bottom: 1px solid rgba(122, 122, 122, 0.196);
  .name {
    margin-bottom: 5px;
  }
  .isSelect {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
  }
}
.flexBox {
  display: flex;
  font-size: 14px;
  color: #333;
  // position: absolute;
  // bottom: 60px;
  width: 100%;
  .hospitalIntroduction,
  .departmentIntroduction {
    position: relative;
    box-sizing: border-box;
    padding: 10px 0;
    width: 47%;
    padding-left: 30px;
    text-align: center;
    background-color: rgb(249, 249, 249);
    border-radius: 5px;
  }
  .hospitalIntroduction {
    margin: 0 2%;
    padding-left: 32px;
  }

  .icon {
    position: absolute;
    left: 24%;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
